import React from "react";
import API from "../../../api/api";
import PageFrame from "../../components/pageFrame";
import GroupOverview from "../../components/groups/group/groupOverview";
import GroupCreated from "../../components/groups/group/groupCreated";
import GroupInvites from "../../components/groups/group/groupInvites";
import GroupInviteCreate from "../../components/groups/group/groupInviteCreate";
import GroupIncomingAttacks from "../../components/groups/group/groupIncomingAttacks";
import GroupMembers from "../../components/groups/group/groupMembers";
import Api from "../../../api/api";

export async function Loader({params}) {
    const {groupId} = params;
    return API.getWithQuery('groups/getFullyDecoratedGroup', {groupId});
}

export const Routes = [
    {path: '', element: <PageFrame pageName={'page/group/overview'}><GroupOverview/></PageFrame>},
    {path: 'created', element: <PageFrame pageName={'page/group/created'}><GroupCreated/></PageFrame>},
    {path: 'invites', element: <PageFrame pageName={'page/group/invites'}><GroupInvites/></PageFrame>},
    {path: 'members', element: <PageFrame pageName={'page/group/members'}><GroupMembers/></PageFrame>},
    {path: 'invites/create', element: <PageFrame pageName={'page/group/invites/create'}><GroupInviteCreate/></PageFrame>},
    {
        path: 'incomingAttacks',
        element: <PageFrame pageName={'page/group/incomingAttacks'}><GroupIncomingAttacks/></PageFrame>,
        loader: async ({params}) => await Api.getWithQuery('userData/travian/incomingAttacks/getForGroup', {groupId: params.groupId})
    },
];
